import { render, staticRenderFns } from "./whitelist.vue?vue&type=template&id=5c6ed576&scoped=true&"
import script from "./whitelist.vue?vue&type=script&lang=ts&"
export * from "./whitelist.vue?vue&type=script&lang=ts&"
import style0 from "./whitelist.vue?vue&type=style&index=0&id=5c6ed576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ed576",
  null
  
)

export default component.exports